import { useTheme } from '@playbooks/contexts';
import { Button } from '@playbooks/ui/components/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from '@playbooks/ui/components/dropdown-menu';
import { Icon } from '@playbooks/ui/components/icon';

const OPTIONS = [
	{ value: 'light', label: 'Light', icon: 'sun-bright' },
	{ value: 'dark', label: 'Dark', icon: 'moon' },
	{ value: 'system', label: 'System', icon: 'desktop' },
] as const;
const DocsThemeMenu = () => {
	const theme = useTheme();
	return (
		<DropdownMenu>
			<DropdownMenuTrigger render={<Button variant='ghost' size='icon-sm' aria-label='Change color theme' />}>
				<Icon type='far' icon={theme.isDark ? 'moon' : 'sun-bright'} aria-hidden />
			</DropdownMenuTrigger>
			<DropdownMenuContent align='end' className='w-36'>
				<DropdownMenuGroup>
					<DropdownMenuLabel>Theme</DropdownMenuLabel>
					{OPTIONS.map(option => (
						<DropdownMenuItem key={option.value} onClick={() => theme.setPreference(option.value)}>
							<Icon type='far' icon={option.icon} aria-hidden />
							<span>{option.label}</span>
							{theme.loaded && theme.preference === option.value && (
								<Icon type='far' icon='check' aria-hidden className='ml-auto' />
							)}
						</DropdownMenuItem>
					))}
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
export { DocsThemeMenu };
